import { PLAYER_MARKET_CATEGORY } from 'app/constants/markets';

const FIRST_SUPPREMACY_MARKETS_BY_VIDEOGAME: Partial<Record<VideogameSlug, string[]>> = {
  'league-of-legends': ['drake', 'kill', 'nashor', 'inhibitor', 'tower', 'atakhan'],
  'dota-2': ['roshan', 'kill', 'tower']
};

const STAR_PLAYER_PREBUILT_TEMPLATES: PrebuiltMarketTemplate[] = [
  'prebuilt-game-winner-and-player-kill-over',
  'prebuilt-game-winner-and-player-kill-under'
];

const MARKET_GROUP_CATEGORY_WITHOUT_SUSPENSION: string[] = ['prebuilt', 'prebuilt-storybuilder'];

const TRADER_INPUT_INCREMENT_BY_VIDEOGAME_BY_CATEGORY: Partial<
  Record<VideogameSlug, Partial<Record<string, number>>>
> = {
  'cs-go': {
    [PLAYER_MARKET_CATEGORY]: 0.1
  }
};

const STATUS_COLOR_MAP: Record<MarketStatus, 'green' | 'orange' | 'red' | 'grey' | 'blue'> = {
  active: 'green',
  suspended: 'orange',
  deactivated: 'red',
  settled: 'grey',
  pre_settled: 'blue'
};

export {
  FIRST_SUPPREMACY_MARKETS_BY_VIDEOGAME,
  STAR_PLAYER_PREBUILT_TEMPLATES,
  MARKET_GROUP_CATEGORY_WITHOUT_SUSPENSION,
  TRADER_INPUT_INCREMENT_BY_VIDEOGAME_BY_CATEGORY,
  STATUS_COLOR_MAP
};
